import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Intro extends Component {

    render() {
        let publicUrl = process.env.PUBLIC_URL + '/';

        // ATENÇÃO: Escolha uma foto bem bonita e vertical para colocar aqui
        let sideImageUrl = publicUrl + "assets/img/banner/serviços.webp"; 

        const goldColor = "#D1AD69";
        const servicos = [
            { label: "Passeio", svg: <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke={goldColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg> },
            { label: "Seguro Viagem", svg: <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke={goldColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg> },
            { label: "Passagem Aérea", svg: <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke={goldColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"/></svg> },
            { label: "Hotel", svg: <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke={goldColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01"/><path d="M16 6h.01"/><path d="M12 6h.01"/><path d="M12 10h.01"/><path d="M12 14h.01"/><path d="M16 10h.01"/><path d="M16 14h.01"/><path d="M8 10h.01"/><path d="M8 14h.01"/></svg> },
            { label: "Ônibus", svg: <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke={goldColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M8 6v6"/><path d="M16 6v6"/><path d="M2 12h20"/><path d="M18 18h2a1 1 0 0 0 1-1V7a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v10a1 1 0 0 0 1 1h2"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg> },
            { label: "Aluguel de Carro", svg: <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke={goldColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9L18 10l-3-5H7L4 10l-2.5 1.1C.7 11.3 0 12.1 0 13v3c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/><path d="M14 17H10"/></svg> },
            { label: "Roteiros Personalizados", svg: <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke={goldColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/><line x1="9" y1="3" x2="9" y2="18"/><line x1="15" y1="6" x2="15" y2="21"/></svg> },
            { label: "Outros", svg: <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke={goldColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg> }
        ];

        return (
            <div className="intro-area pd-top-112">
                
                {/* ESTILOS CSS PERSONALIZADOS */}
                <style>{`
                    /* --- DESKTOP (MODERNO) --- */
                    .service-card-modern {
                        display: flex;
                        align-items: center;
                        background: #fff;
                        padding: 15px;
                        border-radius: 12px;
                        box-shadow: 0 4px 15px rgba(0,0,0,0.05);
                        transition: all 0.3s ease;
                        border: 1px solid #f0f0f0;
                        height: 100%;
                    }
                    
                    .service-card-modern:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 10px 25px rgba(0,0,0,0.1);
                        border-color: #D1AD69;
                    }

                    .service-card-icon {
                        width: 50px;
                        height: 50px;
                        margin-right: 15px;
                        object-fit: contain;
                    }

                    .service-card-text {
                        font-family: 'Poppins', sans-serif;
                        font-weight: 600;
                        color: #333;
                        margin: 0;
                        font-size: 15px;
                        line-height: 1.2;
                    }

                    .side-image-container {
                        height: 100%;
                        min-height: 400px;
                        border-radius: 20px;
                        overflow: hidden;
                        position: relative;
                        box-shadow: 0 10px 30px rgba(0,0,0,0.15);
                    }

                    .side-image {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transition: transform 0.5s ease;
                    }
                    
                    .side-image-container:hover .side-image {
                        transform: scale(1.05);
                    }

                    /* --- MOBILE (ROLAGEM) --- */
                    .swipe-hint { display: none; }

                    @media (max-width: 991px) {
                        /* Esconde a imagem lateral no tablet/mobile */
                        .side-image-col {
                            display: none;
                        }
                        
                        /* Layout de rolagem horizontal */
                        .mobile-scroll-row {
                            display: flex !important;
                            flex-wrap: nowrap !important;
                            overflow-x: auto !important;
                            justify-content: flex-start !important;
                            padding-bottom: 20px; /* Aumentei um pouco para a sombra não cortar */
                            -webkit-overflow-scrolling: touch;
                        }
                        
                        /* CORREÇÃO: Aumentei a largura e ajustei o layout do item */
                        .mobile-scroll-item {
                            flex: 0 0 auto;
                            width: 140px; /* Era 110px, aumentei para caber o texto */
                            margin-right: 12px;
                        }

                        .mobile-scroll-item .service-card-modern {
                            flex-direction: column; 
                            text-align: center;
                            padding: 15px 5px; /* Padding lateral menor para dar espaço ao texto */
                            justify-content: flex-start; /* Alinha tudo ao topo */
                            height: 100%;
                            min-height: 130px; /* Altura mínima para ficarem iguais */
                        }

                        .mobile-scroll-item .service-card-icon {
                            margin-right: 0;
                            margin-bottom: 10px;
                            width: 40px;
                            height: 40px;
                        }

                        /* CORREÇÃO: Ajuste do texto para quebrar linha corretamente */
                        .mobile-scroll-item .service-card-text {
                            font-size: 13px;
                            word-wrap: break-word; /* Quebra palavras longas se precisar */
                            line-height: 1.3;
                        }

                        /* Dica visual */
                        .swipe-hint {
                            display: block;
                            font-size: 12px;
                            color: #999;
                            text-align: right;
                            margin-bottom: 5px;
                            padding-right: 15px;
                            font-weight: 500;
                            animation: pulse 2s infinite;
                        }

                        /* Barras de rolagem */
                        .mobile-scroll-row::-webkit-scrollbar { height: 4px; display: block; }
                        .mobile-scroll-row::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 10px; margin: 0 20px; }
                        .mobile-scroll-row::-webkit-scrollbar-thumb { background: #D1AD69; border-radius: 10px; }
                        
                        @keyframes pulse {
                            0% { opacity: 0.6; transform: translateX(0); }
                            50% { opacity: 1; transform: translateX(3px); }
                            100% { opacity: 0.6; transform: translateX(0); }
                        }
                    }
                `}</style>

                {/* --- ÁREA DE SERVIÇOS MODERNA (Agora é a única coisa aqui) --- */}
                <div className="services-area pd-top-80 pd-bottom-80">
                    <div className="container">
                        
                        <div className="row align-items-center">
                            
                            {/* COLUNA DA ESQUERDA: IMAGEM (Só aparece no Desktop) */}
                            <div className="col-lg-5 mb-4 mb-lg-0 side-image-col">
                                <div className="side-image-container">
                                    <img src={sideImageUrl} alt="Viajando com a Flutuar" className="side-image" />
                                </div>
                            </div>

                            {/* COLUNA DA DIREITA: CONTEÚDO E ÍCONES */}
                            <div className="col-lg-7">
                                <div className="section-title mb-4">
                                    <h2 className="title" style={{ color: '#000' }}>Serviços Exclusivos</h2>
                                    <p className="mb-4">
                                        Muito mais que uma agência. Oferecemos suporte completo para que sua única preocupação seja fazer as malas.
                                    </p>
                                </div>

                                {/* Dica de arrastar (Só Mobile) */}
                                <div className="swipe-hint">Arraste para o lado <i className="fa fa-long-arrow-right"></i></div>

                                {/* GRID DE SERVIÇOS */}
                                <div className="row mobile-scroll-row">
                                    {servicos.map((servico, index) => (
                                        <div className="col-lg-6 col-md-6 mb-3 mobile-scroll-item" key={index}>
                                            <div className="service-card-modern">
                                                <div className="service-card-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    {servico.svg}
                                                </div>
                                                <h5 className="service-card-text">{servico.label}</h5>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default Intro;